var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AuthService } from './../../modules/auth/auth.service';
import { Component } from '@angular/core';
var DashboardUserMenuComponent = (function () {
    function DashboardUserMenuComponent(auth) {
        this.auth = auth;
    }
    DashboardUserMenuComponent.prototype.ngOnInit = function () {
        this.user = this.auth.getProfile();
    };
    DashboardUserMenuComponent.prototype.logout = function () {
        this.auth.logout();
    };
    DashboardUserMenuComponent = __decorate([
        Component({
            selector: 'cx-dashboard-usermenu',
            templateUrl: './dashboard-usermenu.component.html',
        }),
        __metadata("design:paramtypes", [AuthService])
    ], DashboardUserMenuComponent);
    return DashboardUserMenuComponent;
}());
export { DashboardUserMenuComponent };
//# sourceMappingURL=dashboard-user-menu.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/user-menu/dashboard-user-menu.component.js
// module id = 585
// module chunks = 0